import React from "react";

export default function Home() {
  return (
      <div align="center" className="container">
          <div>
            <h1>Happy 80th Birthday</h1>
          </div>
          <div className="col-lg-8" align="center">
              <img
                className="img-fluid rounded mb-4 mb-lg-0"
                src="https://www.vamanaraogaru.com/images/www/image001.jpg"
                style={{ flex: 1, height: 600, width: 800 }}
                alt=""
              />
          </div>
      </div>
  );
}
